export const TAROT_CARDS = [
  {
    name: 'The Fool',
    name_es: 'El Loco',
    image: '/images/tarot-cards/the_fool.png',
  },
  {
    name: 'The Magician',
    name_es: 'El Mago',
    image: '/images/tarot-cards/the_magician.png',
  },
  {
    name: 'The High Priestess',
    name_es: 'La Suma Sacerdotisa',
    image: '/images/tarot-cards/the_high_priestess.png',
  },
  {
    name: 'The Empress',
    name_es: 'La Emperatriz',
    image: '/images/tarot-cards/the_empress.png',
  },
  {
    name: 'The Emperor',
    name_es: 'El Emperador',
    image: '/images/tarot-cards/the_emperor.png',
  },
  {
    name: 'The Hierophant',
    name_es: 'El Papa',
    image: '/images/tarot-cards/the_hierophant.png',
  },
  {
    name: 'The Lovers',
    name_es: 'Los Enamorados',
    image: '/images/tarot-cards/the_lovers.png',
  },
  {
    name: 'The Chariot',
    name_es: 'El Carro',
    image: '/images/tarot-cards/the_chariot.png',
  },
  {
    name: 'Strength',
    name_es: 'La Fuerza',
    image: '/images/tarot-cards/strength.png',
  },
  {
    name: 'The Hermit',
    name_es: 'El Ermitaño',
    image: '/images/tarot-cards/the_hermit.png',
  },
  {
    name: 'Wheel of Fortune',
    name_es: 'La Rueda de la Fortuna',
    image: '/images/tarot-cards/wheel_of_fortune.png',
  },
  {
    name: 'Justice',
    name_es: 'La Justicia',
    image: '/images/tarot-cards/justice.png',
  },
  {
    name: 'The Hanged Man',
    name_es: 'El Colgado',
    image: '/images/tarot-cards/the_hanged_man.png',
  },
  {
    name: 'Death',
    name_es: 'La Muerte',
    image: '/images/tarot-cards/death.png',
  },
  {
    name: 'Temperance',
    name_es: 'La Templanza',
    image: '/images/tarot-cards/temperance.png',
  },
  {
    name: 'The Devil',
    name_es: 'El Diablo',
    image: '/images/tarot-cards/the_devil.png',
  },
  {
    name: 'The Tower',
    name_es: 'La Torre',
    image: '/images/tarot-cards/the_tower.png',
  },
  {
    name: 'The Star',
    name_es: 'La Estrella',
    image: '/images/tarot-cards/the_star.png',
  },
  {
    name: 'The Moon',
    name_es: 'La Luna',
    image: '/images/tarot-cards/the_moon.png',
  },
  {
    name: 'The Sun',
    name_es: 'El Sol',
    image: '/images/tarot-cards/the_sun.png',
  },
  {
    name: 'Judgement',
    name_es: 'El Juicio',
    image: '/images/tarot-cards/judgment.png',
  },
  {
    name: 'The World',
    name_es: 'El Mundo',
    image: '/images/tarot-cards/the_world.png',
  },
];
